
import * as React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Login } from '../routes/auth/Login.js';
import { Register } from '../routes/auth/Register.js';
import { Home } from '../routes/home/Home.js';
import { Alerts } from '../routes/alerts/Alerts.js';
import { Payments } from '../routes/payments/Payments.js';
import { Dates } from '../routes/dates/Dates.js';
import { SettingsShell } from '../routes/settings/SettingsShell.js';
import { Account } from '../routes/settings/account/Account.js';
import { Theme } from '../routes/settings/theme/Theme.js';
import { Devices } from '../routes/settings/devices/Devices.js';
import { Integrations } from '../routes/settings/integrations/Integrations.js';
import { Notifications } from '../routes/settings/notifications/Notifications.js';
import { Notes } from '../routes/notes/Notes.js';
import { ReadingList } from '../routes/reading/ReadingList.js';
import { Subscriptions as SubscriptionsRoute } from '../routes/subscriptions/Subscriptions.js';
import { Tasks } from '../routes/tasks/Tasks.js';
import { Habits } from '../routes/habits/Habits.js';
import { Goals } from '../routes/goals/Goals.js';
import { Travel } from '../routes/travel/Travel.js';
import { Inventory } from '../routes/inventory/Inventory.js';
import { AppShell } from './layout/AppShell.js';
import { RequireAuth } from './layout/RequireAuth.js';

function NotFound(): JSX.Element {
  React.useEffect(() => {
    document.title = 'DailyDeck — Not found';
  }, []);
  return (
    <div className="text-text-primary">
      <h1 className="text-title-2 font-semibold mb-2">Not found</h1>
      <p className="text-body text-text-secondary">That page does not exist.</p>
    </div>
  );
}

export function AppRoutes(): JSX.Element {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />

      <Route element={<RequireAuth />}>
        <Route element={<AppShell />}>
          <Route path="/" element={<Home />} />

          {/* Legacy redirects — old routes now consolidated under /payments */}
          <Route path="/daily-deck" element={<Navigate to="/" replace />} />
          <Route path="/insights" element={<Navigate to="/payments?tab=insights" replace />} />
          <Route path="/payments/review" element={<Navigate to="/payments?tab=review" replace />} />
          <Route path="/payments/recurring" element={<Navigate to="/payments?tab=recurring" replace />} />

          <Route path="/alerts" element={<Alerts />} />
          <Route path="/payments" element={<Payments />} />
          <Route path="/dates" element={<Dates />} />
          <Route path="/notes" element={<Notes />} />
          <Route path="/reading" element={<ReadingList />} />
          <Route path="/subscriptions" element={<SubscriptionsRoute />} />
          <Route path="/tasks" element={<Tasks />} />
          <Route path="/habits" element={<Habits />} />
          <Route path="/goals" element={<Goals />} />\n          <Route path="/travel" element={<Travel />} />\n          <Route path="/inventory" element={<Inventory />} />

          <Route path="/settings" element={<SettingsShell />}>
            <Route index element={<Navigate to="/settings/account" replace />} />
            <Route path="account" element={<Account />} />
            <Route path="theme" element={<Theme />} />
            <Route path="devices" element={<Devices />} />
            <Route path="integrations" element={<Integrations />} />
            <Route path="notifications" element={<Notifications />} />
          </Route>

          <Route path="*" element={<NotFound />} />
        </Route>
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
